<template>
    <div class="overhaul-excute-con">
        <div>
            <el-form :inline="true" ref="searchForm" class="leader-style-form">
                <el-form-item label="单号">
                    <el-input maxlength="50" v-model="searchForm.check_repair_no"></el-input>
                </el-form-item>
                <el-form-item label="计划检修时间">
                    <el-date-picker
                        type="date"
                        v-model="searchForm.plan_time_start"
                        placeholder="选择日期"
                        :default-value="timeNow"
                        value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="检修状态">
                    <el-select v-model="searchForm.check_repair_state">
                        <el-option
                            v-for="item in checkRepairStates"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getCheckResultList" type="warning">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-wrap">
            <el-table :data="tableData" border class="leader-style-table">
                <el-table-column width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        <span>
                            {{
                                (pageNum - 1) * pageSize + scope.$index + 1
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="单号" property="check_repair_no" align="center"></el-table-column>
                <el-table-column label="常规检修设备数量" property="repair_num" align="center"></el-table-column>
                <el-table-column label="待检修项目数量" property="wait_repair_num" align="center"></el-table-column>
                <el-table-column label="计划开始时间" property="plan_time_start" align="center"></el-table-column>
                <el-table-column label="是否停电" property="is_power_cut" align="center"></el-table-column>
                <el-table-column label="工作负责人" property="leader_name" align="center"></el-table-column>
                <el-table-column label="计划状态" property="check_repair_state_name" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="inputOverhaulShow(scope.row)"
                            type="text"
                            class="button-custom"
                            v-pms="'btn_overhaul_excute_input'"
                        >
                            <!-- :disabled="scope.row.check_repair_state == '40'" -->
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">检修记录填写</span>
                        </el-button>
                        <!-- <el-button
                            @click="arrangeDefectShow(scope.row)"
                            type="text"
                            class="leader-button check-button"
                        >
                            <i class="iconfont iconsearch"></i>
                            <span class="inner-text">查看</span>
                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                style="margin-top: 20px"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                class="leader-style-pagination"
            ></el-pagination>
        </div>
        <el-dialog
            class="leader-dialog"
            :title="dialogTitle"
            width="1000px"
            :visible.sync="overExcuteVisible"
            @close="closeDialog"
            :close-on-click-modal="false"
            :destroy-on-close="true"
        >
            <el-scrollbar style="height: 500px;">
                <div>
                    <el-tabs
                        style="margin: 0px"
                        v-model="tabVal"
                        type="card"
                        @tab-click="handleTabClick"
                    >
                        <el-tab-pane label="检修信息回填" name="tab1"></el-tab-pane>
                        <el-tab-pane label="票证回填" name="tab2"></el-tab-pane>
                        <el-tab-pane label="备件/材料消耗" name="tab3"></el-tab-pane>
                        <el-tab-pane label="工作总结" name="tab4"></el-tab-pane>
                    </el-tabs>
                </div>

                <div v-if="tabVal == 'tab1'">
                    <el-form
                        :rules="formRules1"
                        :model="addForm1"
                        ref="addForm1"
                        class="leader-style-form"
                    >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item
                                    label="实际开始时间"
                                    :label-width="labelWidth"
                                    prop="check_repair_time_start"
                                >
                                    <el-date-picker
                                        type="date"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        style="width: 100%"
                                        v-model="
                                            addForm1.check_repair_time_start
                                        "
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="实际结束时间"
                                    :label-width="labelWidth"
                                    prop="check_repair_time_end"
                                >
                                    <el-date-picker
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        v-model="addForm1.check_repair_time_end"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="实际内部检修人员"
                                    :label-width="labelWidth"
                                    prop="worker_ids"
                                >
                                    <el-input maxlength="30" v-model="addForm1.worker_ids"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="实际外部检修人员"
                                    :label-width="labelWidth"
                                    prop="out_worker_name"
                                >
                                    <el-input maxlength="30" v-model="addForm1.out_worker_name"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-scrollbar style="height: 270px">
                            <el-table
                                border
                                :data="addForm1.repair_tree_list"
                                style="width: 100%"
                                class="leader-style-table"
                            >
                                <el-table-column width="50" align="center" label="序号">
                                    <template slot-scope="scope">
                                        <span>{{ scope.$index + 1 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column v-show="false" width="1px">
                                    <template slot-scope="scope">
                                        <el-form-item>
                                            <el-input
                                                v-show="false"
                                                v-model="
                                                    scope.row
                                                        .check_repair_tree_id
                                                "
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="设备名称" property="tree_name"></el-table-column>
                                <el-table-column label="任务来源" property="task_source"></el-table-column>
                                <el-table-column label="工作内容" property="repair_content"></el-table-column>
                                <el-table-column label="检修结果" align="center" width="100px">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'repair_tree_list.' +
                                                scope.$index +
                                                '.is_complete'
                                            "
                                        ></el-form-item>
                                        <el-switch
                                            v-model="scope.row.is_complete"
                                            active-color="#13ce66"
                                        ></el-switch>
                                    </template>
                                </el-table-column>
                                <el-table-column label="检修过程描述">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'repair_tree_list.' +
                                                scope.$index +
                                                '.check_repair_content'
                                            "
                                        >
                                            <el-input
                                                v-model="
                                                    scope.row
                                                        .check_repair_content
                                                "
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-scrollbar>
                    </el-form>

                    <div class="dialog-footer" style="margin-top: 10px">
                        <el-button
                            type="primary"
                            @click="checkInDefect"
                            class="leader-common-button"
                        >登记缺陷</el-button>
                        <el-button
                            @click="overExcuteVisible = false"
                            class="leader-common-button"
                        >取消</el-button>
                        <el-button
                            type="primary"
                            @click="commitTab1('addForm1')"
                            class="leader-common-button"
                        >保存</el-button>
                    </div>
                </div>

                <div v-if="tabVal == 'tab2'">
                    <el-scrollbar style="height: 400px;">
                        <el-card
                            class="box-card leader-card"
                            style="color: #fff;background-color: transparent;border: 0px;"
                        >
                            <div slot="header" class="clearfix them_font_color">
                                <span>工作票信息</span>
                                <el-button
                                    type="primary"
                                    style="float: right;margin-top: -16px"
                                    @click="gZPClick()"
                                >+ 新增</el-button>
                            </div>
                            <el-table
                                border
                                :data="gZPDatas"
                                style="width: 100%"
                                height="100%"
                                class="leader-style-table"
                            >
                                <el-table-column label="票号" property="ticket_code"></el-table-column>
                                <el-table-column label="票种类" property="ticket_type_name"></el-table-column>
                                <el-table-column label="计划工作时间" property="plan_time_start"></el-table-column>
                                <el-table-column
                                    label="工作负责人"
                                    property="work_leader_name"
                                    width="100"
                                ></el-table-column>
                                <el-table-column label="状态" property="status" width="50"></el-table-column>
                                <el-table-column label="操作" align="center" width="200">
                                    <template slot-scope="scope">
                                        <el-button
                                            @click="changeGzpShow(scope.row)"
                                            type="text"
                                            class="button-modify"
                                        >
                                            <i class="iconfont iconeditor"></i>
                                            <span class="inner-text">修改</span>
                                        </el-button>
                                        <el-button
                                            @click="deleteGzpItem(scope.row)"
                                            type="text"
                                            class="button-delete"
                                        >
                                            <i class="iconfont iconashbin"></i>
                                            <span class="inner-text">删除</span>
                                        </el-button>
                                        <el-button
                                            @click="arrangeGzpShow(scope.row)"
                                            type="text"
                                            class="button-check"
                                        >
                                            <i class="iconfont iconsearch"></i>
                                            <span class="inner-text">查看</span>
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                        <el-card
                            class="box-card"
                            style="color: #fff;background-color: transparent;border: 0px;"
                        >
                            <div slot="header" class="clearfix them_font_color">
                                <span>操作票信息</span>
                                <el-button
                                    @click="czpClick()"
                                    type="primary"
                                    style="float: right;margin-top: -16px"
                                >+ 新增</el-button>
                            </div>
                            <el-table
                                border
                                :data="cZPDatas"
                                style="width: 100%"
                                height="100%"
                                class="leader-style-table"
                            >
                                <el-table-column label="票号" property="ticket_code"></el-table-column>
                                <el-table-column label="发令时间" property="send_time"></el-table-column>
                                <el-table-column label="受令人" property="receiver_name"></el-table-column>
                                <el-table-column label="操作开始时间" property="time_start"></el-table-column>
                                <el-table-column label="状态" width="50" property="status"></el-table-column>
                                <el-table-column label="操作" width="200" align="center">
                                    <template slot-scope="scope">
                                        <el-button
                                            @click="changeCzpShow(scope.row)"
                                            type="text"
                                            class="button-modify"
                                        >
                                            <i class="iconfont iconeditor"></i>
                                            <span class="inner-text">修改</span>
                                        </el-button>
                                        <el-button
                                            @click="deleteCzpItem(scope.row)"
                                            type="text"
                                            class="button-delete"
                                        >
                                            <i class="iconfont iconashbin"></i>
                                            <span class="inner-text">删除</span>
                                        </el-button>
                                        <el-button
                                            @click="arrangeCzpShow(scope.row)"
                                            type="text"
                                            class="button-check"
                                        >
                                            <i class="iconfont iconsearch"></i>
                                            <span class="inner-text">查看</span>
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-scrollbar>
                </div>

                <div v-if="tabVal == 'tab3'">
                    <el-button
                        type="primary"
                        @click="addBeiJian"
                        style="margin-bottom: 20px;"
                        class="leader-common-button"
                    >+ 新增</el-button>
                    <el-form :model="addForm3" ref="addForm3" class="form-table leader-style-form">
                        <el-scrollbar style="height: 320px;margin-bottom: 20px;">
                            <el-table
                                :data="addForm3.list"
                                highlight-current-row
                                border
                                ref="tableRef"
                                max-height="550"
                                class="leader-style-table"
                            >
                                <el-table-column label="序号" align="center" width="50">
                                    <template slot-scope="scope">
                                        <span>{{ scope.$index + 1 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="材料/备件" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'list.' +
                                                scope.$index +
                                                '.parts_name'
                                            "
                                            :rules="[
                                                { required: true, message: '' },
                                            ]"
                                        >
                                            <el-input v-model="scope.row.parts_name"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="型号" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'list.' +
                                                scope.$index +
                                                '.parts_model'
                                            "
                                            :rules="[
                                                { required: true, message: '' },
                                            ]"
                                        >
                                            <el-input v-model="scope.row.parts_model"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="数量" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'list.' +
                                                scope.$index +
                                                '.parts_num'
                                            "
                                            :rules="[
                                                { required: true, message: '' },
                                            ]"
                                        >
                                            <el-input v-model="scope.row.parts_num"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="单位" align="center">
                                    <template slot-scope="scope">
                                        <el-form-item
                                            :prop="
                                                'list.' +
                                                scope.$index +
                                                '.parts_unit'
                                            "
                                            :rules="[
                                                { required: true, message: '' },
                                            ]"
                                        >
                                            <el-input v-model="scope.row.parts_unit"></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column label="修改" align="center" width="100">
                                    <template slot-scope="scope">
                                        <el-button
                                            type="danger"
                                            size="small"
                                            @click="deleteItem(scope.row)"
                                        >删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-scrollbar>
                    </el-form>
                    <div class="dialog-footer">
                        <el-button
                            type="primary"
                            @click="checkInDefect"
                            class="leader-common-button"
                        >登记缺陷</el-button>
                        <el-button
                            @click="overExcuteVisible = false"
                            class="leader-common-button"
                        >取消</el-button>
                        <el-button
                            type="primary"
                            @click="commitTab3('addForm3')"
                            class="leader-common-button"
                        >保存</el-button>
                    </div>
                </div>

                <div v-if="tabVal == 'tab4'">
                    <div style="height: 380px;">
                        <el-form :model="addForm4" ref="addForm4" class="leader-style-form">
                            <el-form-item
                                label="检修工作总结"
                                style="width: 100%;"
                                :label-width="labelWidth120"
                            >
                                <el-input v-model="addForm4.remark" type="textarea" rows="7"></el-input>
                            </el-form-item>
                            <el-form-item label="相关附件上传" :label-width="labelWidth120">
                                <el-upload
                                    style="margin-top: 20px;text-align: left"
                                    :class="{ disabled: uploadDisabled }"
                                    class="avatar-uploader"
                                    action
                                    multiple
                                    :http-request="uploadFile"
                                    list-type="picture-card"
                                    :file-list="FileImgs"
                                    :on-remove="handleRemove"
                                    accept=".jpg, , jpeg, .png, .gif, .bmp"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="dialog-footer" style="margin-top: 10px">
                        <el-button
                            type="primary"
                            @click="checkInDefect"
                            class="leader-common-button"
                        >登记缺陷</el-button>
                        <el-button
                            @click="overExcuteVisible = false"
                            class="leader-common-button"
                        >取消</el-button>
                        <el-button
                            type="primary"
                            @click="commitTab4('addForm4')"
                            class="leader-common-button"
                        >保存</el-button>
                    </div>
                </div>
            </el-scrollbar>
        </el-dialog>
        <!-- 工作票选择 -->
        <el-dialog
            title="新增工作票"
            width="500px"
            :visible.sync="gzpVisible"
            @close="closeDialogGzp"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            class="leader-dialog"
        >
            <el-form :rules="gzpFormRules" :model="gzpForm" ref="gzpForm" class="leader-style-form">
                <el-form-item label="票种类">
                    <el-select v-model="gzpForm.ticket_type" style="width: 100%">
                        <el-option
                            v-for="item in gzpTypes"
                            :key="item.code_value"
                            :label="item.code_name"
                            :value="item.code_value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="gzpVisible = false" class="leader-common-button">取消</el-button>
                <el-button
                    type="primary"
                    @click="commitAddGzp('addForm1')"
                    class="leader-common-button"
                >确定</el-button>
            </div>
        </el-dialog>
        <!-- 第一种工作票 -->
        <el-dialog
            title="工作票"
            width="1000px"
            :visible.sync="firstGzpVisible"
            @close="closeDialogFirstGzp"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            class="leader-dialog"
        >
            <el-scrollbar style="height: 440px">
                <el-form
                    :rules="firstGzpFormRules"
                    :model="firstGzpForm"
                    ref="firstGzpForm"
                    class="leader-style-form"
                >
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="编号" :label-width="labelWidth">
                                <el-input
                                    :disabled="isGzpLook"
                                    maxlength="50"
                                    v-model="firstGzpForm.ticket_code"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作的变配电室名称" :label-width="labelWidth">
                                <el-input
                                    :disabled="isGzpLook"
                                    maxlength="50"
                                    v-model="firstGzpForm.addr"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作负责人" :label-width="labelWidth">
                                <el-select
                                    :disabled="isGzpLook"
                                    style="width: 100%"
                                    v-model="firstGzpForm.leader_name"
                                    @change="changeLeader"
                                >
                                    <el-option
                                        v-for="item in leaders"
                                        :key="item.leader_user_id"
                                        :label="item.leader_name"
                                        :value="item.leader_user_id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作班成员" :label-width="labelWidth">
                                <el-select
                                    :disabled="isGzpLook"
                                    style="width: 100%"
                                    multiple
                                    v-model="firstGzpForm.worker_names"
                                >
                                    <el-option
                                        v-for="item in workers"
                                        :key="item.user_id"
                                        :label="item.user_name"
                                        :value="item.user_id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">工作任务</span>
                            <el-button
                                type="primary"
                                style="float: right;margin-top: -30px !important"
                                @click="firstGzpTask"
                                v-if="!isGzpLook"
                                class="leader-common-button"
                            >+ 新增</el-button>
                        </div>
                        <el-table
                            :data="firstGzpForm.task_list"
                            highlight-current-row
                            border
                            ref="tableRef"
                            class="leader-style-form"
                        >
                            <el-table-column label="序号" align="center" width="50">
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="设备双重名称" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.task_name"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="工作内容" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.task_content"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="修改"
                                align="center"
                                width="100"
                                v-if="!isGzpLook"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="danger"
                                        size="small"
                                        @click="deleteFirstGzpTask(scope.row)"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                    <el-row :gutter="20" style="margin-top: 20px;">
                        <el-col :span="12">
                            <el-form-item label="计划开始时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.plan_time_start"
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计划结束时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.plan_time_end"
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    style="width: 100%"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">安全措施</span>
                            <el-button
                                type="primary"
                                style="float: right;margin-top: -30px !important"
                                @click="firstGzpSafe"
                                v-if="!isGzpLook"
                                class="leader-common-button"
                            >+ 新增</el-button>
                        </div>
                        <el-table
                            :data="firstGzpForm.safe_list"
                            highlight-current-row
                            border
                            ref="tableRef"
                            class="leader-style-table"
                        >
                            <el-table-column label="序号" align="center" width="50">
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="由工作负责人填写" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.safe_name"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="由工作许可人填写" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.safe_content"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="修改"
                                align="center"
                                width="100"
                                v-if="!isGzpLook"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="danger"
                                        size="small"
                                        @click="deleteFirstGzpSafe(scope.row)"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                    <el-row :gutter="20" style="margin-top: 20px;">
                        <el-col :span="12">
                            <el-form-item label="工作票签发人签名" :label-width="labelWidth">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.work_send_person"
                                    maxlength="30"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="签发时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.work_send_time"
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span
                                style="display: block;text-align:center;font-size: 18px;"
                            >确认本工作票上述各项内容</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="许可开始时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.work_agree_time_start
                                        "
                                        type="date"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        style="width: 100%"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作许可人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.work_agree_person"
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作负责人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.work_leader_name"
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span
                                style="display: block;text-align:center;font-size: 18px;"
                            >确认工作负责人布置的工作任务和安全措施</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="工作班组人员签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.require_works_name
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span
                                style="display: block;text-align:center;font-size: 18px;"
                            >工作负责人变动情况</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="原工作负责人" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.change_content_from
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="变更为" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.change_content_to"
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作票签发人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.change_send_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.change_send_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作许可人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.change_agree_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.change_agree_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item
                                    label="工作人员变动情况"
                                    style="width: 100%;"
                                    :label-width="labelWidth"
                                >
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.change_content"
                                        type="textarea"
                                        rows="4"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作负责人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.change_worker_leader_name
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">工作票延期</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="有效期延长到" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.delay_to_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作负责人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.delay_duty_person"
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.delay_duty_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="工作许可人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.delay_agree_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.delay_agree_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span
                                style="display: block;text-align:center;font-size: 18px;"
                            >每日开工和收工时间</span>
                            <el-button
                                type="primary"
                                style="float: right;margin-top: -30px !important"
                                @click="firstGzpTime"
                                v-if="!isGzpLook"
                                class="leader-common-button"
                            >+ 新增</el-button>
                        </div>
                        <el-table
                            :data="firstGzpForm.time_list"
                            highlight-current-row
                            border
                            ref="tableRef"
                            class="leader-style-table"
                        >
                            <el-table-column label="开工时间" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-date-picker
                                            :disabled="isGzpLook"
                                            v-model="scope.row.start_time"
                                            type="date"
                                            placeholder="选择日期"
                                            :default-value="timeNow"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            :picker-options="pickerOptions"
                                        ></el-date-picker>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="工作负责人" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="
                                                scope.row.start_duty_person
                                            "
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="工作许可人" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="
                                                scope.row.start_agree_person
                                            "
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="收工时间" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-date-picker
                                            :disabled="isGzpLook"
                                            v-model="scope.row.end_time"
                                            type="date"
                                            placeholder="选择日期"
                                            :default-value="timeNow"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            :picker-options="pickerOptions"
                                        ></el-date-picker>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="工作负责人" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.end_duty_person"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="工作许可人" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.end_agree_person"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="修改"
                                align="center"
                                width="100"
                                v-if="!isGzpLook"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="danger"
                                        size="small"
                                        @click="deleteFirstGzpTime(scope.row)"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">工作票总结</span>
                        </div>
                        <div class="them_font_color">
                            1、全部工作票于
                            <el-form-item style="display: inline-block">
                                <el-date-picker
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.finish_content_time"
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>结束，设备及安全措施已恢复至开工前状态，工作
                            人员全部撤离，材料工具已清理完毕。
                        </div>
                        <div class="them_font_color">
                            2、临时遮拦、标识牌已拆除，常设遮拦已恢复。已拆除或已拉开的接地线编号
                            <el-form-item style="display: inline-block">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.finish_content_no"
                                ></el-input>
                            </el-form-item>等共
                            <el-form-item style="display: inline-block">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.finish_content_groups"
                                ></el-input>
                            </el-form-item>组、接地刀闸（小车）共
                            <el-form-item style="display: inline-block">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.finish_content_count"
                                ></el-input>
                            </el-form-item>副（台）。
                        </div>
                        <div class="them_font_color">
                            3、因
                            <el-form-item style="display: inline-block">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.un_finish_content"
                                ></el-input>
                            </el-form-item>工作未结束，未拆除或未拉开的接地线编号
                            <el-form-item style="display: inline-block">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="firstGzpForm.un_finish_content_no"
                                ></el-input>
                            </el-form-item>等共
                            <el-form-item style="display: inline-block">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="
                                        firstGzpForm.un_finish_content_groups
                                    "
                                ></el-input>
                            </el-form-item>组、接地刀闸（小车）共
                            <el-form-item style="display: inline-block">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="
                                        firstGzpForm.un_finish_content_count
                                    "
                                ></el-input>
                            </el-form-item>（副/台）。
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="工作负责人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.finish_duty_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.finish_duty_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="工作许可人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            firstGzpForm.finish_agree_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="firstGzpForm.finish_agree_time"
                                        type="date"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        style="width: 100%"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-form>
            </el-scrollbar>

            <div slot="footer" class="dialog-footer" v-if="!isGzpLook">
                <el-button @click="closeDialogFirstGzp" class="leader-common-button">取消</el-button>
                <el-button
                    type="primary"
                    @click="commitFirstGzp('firstGzpForm')"
                    class="leader-common-button"
                >保存</el-button>
            </div>
        </el-dialog>
        <!-- 第二种工作票 -->
        <el-dialog
            title="工作票"
            width="1000px"
            :visible.sync="secondGzpVisible"
            @close="closeDialogSecondGzp"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            class="leader-dialog"
        >
            <el-scrollbar style="height: 440px">
                <el-form :model="secondGzpForm" ref="secondGzpForm" class="leader-style-form">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="编号" :label-width="labelWidth">
                                <el-input
                                    :disabled="isGzpLook"
                                    maxlength="50"
                                    v-model="secondGzpForm.ticket_code"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作的变配电室名称" :label-width="labelWidth">
                                <el-input
                                    :disabled="isGzpLook"
                                    maxlength="50"
                                    v-model="secondGzpForm.addr"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作负责人" :label-width="labelWidth">
                                <el-select
                                    :disabled="isGzpLook"
                                    style="width: 100%"
                                    v-model="secondGzpForm.leader_name"
                                    @change="changeLeaderSecond"
                                >
                                    <el-option
                                        v-for="item in leaders"
                                        :key="item.leader_user_id"
                                        :label="item.leader_name"
                                        :value="item.leader_user_id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作班成员" :label-width="labelWidth">
                                <el-select
                                    :disabled="isGzpLook"
                                    style="width: 100%"
                                    multiple
                                    v-model="secondGzpForm.worker_names"
                                >
                                    <el-option
                                        v-for="item in workers"
                                        :key="item.user_id"
                                        :label="item.user_name"
                                        :value="item.user_id"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">工作任务</span>
                            <el-button
                                type="primary"
                                style="float: right;margin-top: -30px !important"
                                @click="secondGzpTask"
                                v-if="!isGzpLook"
                                class="leader-common-button"
                            >+ 新增</el-button>
                        </div>
                        <el-table
                            :data="secondGzpForm.task_list"
                            highlight-current-row
                            border
                            ref="tableRef"
                            class="leader-style-table"
                        >
                            <el-table-column label="序号" align="center" width="50">
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="设备双重名称" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.task_name"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="工作内容" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isGzpLook"
                                            v-model="scope.row.task_content"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="修改"
                                align="center"
                                width="100"
                                v-if="!isGzpLook"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="danger"
                                        size="small"
                                        @click="deleteSecondGzpTask(scope.row)"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>

                    <el-row :gutter="20" style="margin-top: 20px;">
                        <el-col :span="12">
                            <el-form-item label="计划开始时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isGzpLook"
                                    v-model="secondGzpForm.plan_time_start"
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    style="width: 100%"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计划结束时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isGzpLook"
                                    v-model="secondGzpForm.plan_time_end"
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    style="width: 100%"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="工作条件"
                                style="width: 100%;"
                                :label-width="labelWidth"
                            >
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="secondGzpForm.condition"
                                    type="textarea"
                                    rows="4"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作票负责人" :label-width="labelWidth">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="secondGzpForm.duty_person"
                                    maxlength="30"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作票许可人" :label-width="labelWidth">
                                <el-input
                                    :disabled="isGzpLook"
                                    v-model="secondGzpForm.agree_person"
                                    maxlength="30"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span
                                style="display: block;text-align:center;font-size: 18px;"
                            >确认本工作票上述各项内容</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="工作票签发人" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.work_send_person"
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作负责人" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.work_leader_name"
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作许可人" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            secondGzpForm.work_agree_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="工作许可时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.work_agree_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span
                                style="display: block;text-align:center;font-size: 18px;"
                            >确认工作负责人布置的工作任务和安全措施</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="工作班组人员签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            secondGzpForm.require_works_name
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>

                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">工作票延期</span>
                        </div>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="有效期延长到" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.delay_to_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="工作负责人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            secondGzpForm.delay_duty_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.delay_duty_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="工作许可人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            secondGzpForm.delay_agree_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.delay_agree_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>

                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;margin-top: 20px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">工作票总结</span>
                        </div>
                        <div class="them_font_color">
                            全部工作票于
                            <el-form-item style="display: inline-block">
                                <el-date-picker
                                    :disabled="isGzpLook"
                                    v-model="secondGzpForm.finish_content_time"
                                    type="date"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>结束，设备及安全措施已恢复至开工前状态，工作
                            人员全部撤离，材料工具已清理完毕。
                        </div>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="工作负责人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            secondGzpForm.finish_duty_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.finish_duty_time"
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="工作许可人签名" :label-width="labelWidth">
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="
                                            secondGzpForm.finish_agree_person
                                        "
                                        maxlength="30"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时间" :label-width="labelWidth">
                                    <el-date-picker
                                        :disabled="isGzpLook"
                                        v-model="
                                            secondGzpForm.finish_agree_time
                                        "
                                        type="date"
                                        style="width: 100%"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item
                                    label="备注"
                                    style="width: 100%;"
                                    :label-width="labelWidth"
                                >
                                    <el-input
                                        :disabled="isGzpLook"
                                        v-model="secondGzpForm.remark"
                                        type="textarea"
                                        rows="4"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-form>
            </el-scrollbar>

            <div slot="footer" class="dialog-footer" v-if="!isGzpLook">
                <el-button @click="secondGzpVisible = false" class="leader-common-button">取消</el-button>
                <el-button
                    type="primary"
                    @click="commitSecondGzp('secondGzpForm')"
                    class="leader-common-button"
                >保存</el-button>
            </div>
        </el-dialog>
        <!-- 操作票 -->
        <el-dialog
            title="操作票"
            width="1000px"
            :visible.sync="czpVisible"
            @close="closeDialogCzp"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            class="leader-dialog"
        >
            <el-scrollbar style="height: 440px">
                <el-form :model="czpForm" ref="czpForm" class="leader-style-form">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="编号" :label-width="labelWidth">
                                <el-input
                                    :disabled="isCzpLook"
                                    maxlength="50"
                                    v-model="czpForm.ticket_code"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="配电室名称" :label-width="labelWidth">
                                <el-input
                                    :disabled="isCzpLook"
                                    maxlength="50"
                                    v-model="czpForm.addr"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发令人" :label-width="labelWidth">
                                <el-input
                                    :disabled="isCzpLook"
                                    maxlength="50"
                                    v-model="czpForm.sender_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="受令人" :label-width="labelWidth">
                                <el-input
                                    :disabled="isCzpLook"
                                    maxlength="50"
                                    v-model="czpForm.receiver_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发令时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isCzpLook"
                                    v-model="czpForm.send_time"
                                    type="date"
                                    style="width: 100%"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="操作开始时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isCzpLook"
                                    v-model="czpForm.time_start"
                                    type="date"
                                    style="width: 100%"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="操作结束时间" :label-width="labelWidth">
                                <el-date-picker
                                    :disabled="isCzpLook"
                                    v-model="czpForm.time_end"
                                    type="date"
                                    style="width: 100%"
                                    placeholder="选择日期"
                                    :default-value="timeNow"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="操作人" :label-width="labelWidth">
                                <el-input
                                    :disabled="isCzpLook"
                                    maxlength="50"
                                    v-model="czpForm.operationer_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="监护人" :label-width="labelWidth">
                                <el-input
                                    :disabled="isCzpLook"
                                    maxlength="50"
                                    v-model="czpForm.guardian_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="审核人" :label-width="labelWidth">
                                <el-input
                                    :disabled="isCzpLook"
                                    maxlength="50"
                                    v-model="czpForm.checker_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-card
                        class="box-card"
                        style="color: #fff;background-color: transparent;border: 0px;"
                    >
                        <div slot="header" class="clearfix them_font_color">
                            <span style="display: block;text-align:center;font-size: 18px;">操作任务</span>
                            <el-button
                                type="primary"
                                style="float: right;margin-top: -30px !important"
                                @click="czpTask"
                                v-if="!isCzpLook"
                                class="leader-common-button"
                            >+ 新增</el-button>
                        </div>
                        <el-table
                            :data="czpForm.task_list"
                            highlight-current-row
                            border
                            ref="tableRef"
                            class="leader-style-table"
                        >
                            <el-table-column label="序号" align="center" width="50">
                                <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作项目" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isCzpLook"
                                            v-model="scope.row.task_name"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="模拟操作" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isCzpLook"
                                            v-model="
                                                scope.row.simulation_content
                                            "
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column label="实际操作" align="center">
                                <template slot-scope="scope">
                                    <el-form-item>
                                        <el-input
                                            :disabled="isCzpLook"
                                            v-model="scope.row.real_content"
                                        ></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="修改"
                                align="center"
                                width="100"
                                v-if="!isCzpLook"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="danger"
                                        size="small"
                                        @click="deleteCzpTask(scope.row)"
                                    >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-form>
            </el-scrollbar>

            <div slot="footer" class="dialog-footer" v-if="!isCzpLook">
                <el-button @click="czpVisible = false" class="leader-common-button">取消</el-button>
                <el-button
                    type="primary"
                    @click="commitCzp('czpForm')"
                    class="leader-common-button"
                >保存</el-button>
            </div>
        </el-dialog>
        <AddDefentDialog :defentDialogVisible.sync="defentDialogVisible" class="leader-dialog"></AddDefentDialog>
    </div>
</template>
<script>
import * as api from '../api/index';
import AddDefentDialog from '../defect_manage/components/add_defent_dialog';
export default {
    components: { AddDefentDialog },
    data() {
        return {
            defentDialogVisible: false,
            labelWidth: '180px',
            labelWidth120: '120px',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            searchForm: {
                from_id: '',
            },
            tableData: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            checkRepairStates: [],
            dialogTitle: '检修记录填写',
            overExcuteVisible: false,
            tabVal: 'tab1',
            check_repair_result_id: '', //每条数据的id
            addForm1: {
                check_repair_time_start: '', //实际开始时间
                check_repair_time_end: '', //实际结束时间
                worker_ids: '', //内部检修人员
                out_worker_name: '', //外部检修人员
                repair_tree_list: [],
            },
            formRules1: {
                check_repair_time_start: [
                    {
                        required: true,
                        message: '请选择实际开始时间',
                        trigger: 'change',
                    },
                ],
                check_repair_time_end: [
                    {
                        required: true,
                        message: '请选择实际结束时间',
                        trigger: 'change',
                    },
                ],
            },
            gzpVisible: false,
            gzpForm: {
                ticket_type: '',
            },
            ticketType: '',
            gzpTypes: [
                {
                    code_name: '第一种工作票',
                    code_value: '10',
                },
                {
                    code_name: '第二种工作票',
                    code_value: '20',
                },
            ],
            gZPDatas: [],
            isGzpLook: false, //是否查看工作票
            firstGzpVisible: false, //第一种工作票
            firstGzpForm: {
                ticket_code: '', //编号
                addr: '', //工作变配电室名称
                leader_name: '', //工作负责人
                worker_names: '',
                task_list: [], //工作任务
                plan_time_start: '',
                plan_time_end: '',
                safe_list: [], //安全措施
                work_send_person: '', //工作票签发人签名
                work_send_time: '', //签发时间
                work_agree_time_start: '', //许可开始时间
                work_agree_person: '', //工作许可人签名
                work_leader_name: '', //工作负责人签名
                require_works_name: '', //工作班组人员签名
                change_content_from: '', //原工作负责人
                change_content_to: '', //变更后负责人
                change_send_person: '', //工作票签发人签名
                change_send_time: '', //变动负责人工作票签发时间
                change_agree_person: '', //变动工作许可人签名
                change_agree_time: '', //变动负责人工作许可人签名日期
                change_content: '', //变动情况说明
                change_worker_leader_name: '', //变动工人负责人签名
                delay_to_time: '', //有效期延长到
                delay_duty_person: '', //工作负责人签名
                delay_duty_time: '', //工作负责人签名日期
                delay_agree_person: '', //工作许可人签名
                delay_agree_time: '', //工作许可人签名日期
                time_list: [], //每日开工和收工时间
                finish_content_time: '', //总结结束时间
                finish_content_no: '', //总结接地线编号
                finish_content_groups: '', //总结接地线组数
                finish_content_count: '', //接地刀闸台数
                un_finish_content: '', //总结未结束
                un_finish_content_no: '', //总结未结束接地线编号
                un_finish_content_groups: '', //总结未结束接地线组数
                un_finish_content_count: '', //未结束接地刀闸台数
                finish_duty_person: '', //总结工作负责人签名
                finish_duty_time: '', //总结工作负责人签名日期
                finish_agree_person: '', //总结工作许可人签名
                finish_agree_time: '', //
            },
            secondGzpVisible: false,
            secondGzpForm: {
                ticket_code: '', //编号
                addr: '', //变配电室名称
                leader_name: '', //工作负责人
                worker_names: '', //工作班成员
                task_list: [], //工作任务
                plan_time_start: '', //计划开始时间
                plan_time_end: '', //计划结束时间
                condition: '', //工作条件
                duty_person: '', //工作票负责人
                agree_person: '', //工作票许可人
                work_send_person: '', //工作票签发人
                work_leader_name: '', //工作负责人
                work_agree_person: '', //工作许可人
                work_agree_time: '', //工作许可时间
                require_works_name: '', //确认工作负责人-工作人员
                delay_to_time: '', //有效期延长到
                delay_duty_person: '', //工作负责人签名
                delay_duty_time: '', //工作负责人签名日期
                delay_agree_person: '', //工作许可人签名
                delay_agree_time: '', //工作许可人签名日期
                finish_content_time: '', //
                finish_duty_person: '', //总结工作负责人签名
                finish_duty_time: '', //总结工作负责人签名日期
                finish_agree_person: '', //总结工作许可人签名
                finish_agree_time: '', //总结工作许可人签名日期
                remark: '',
            },
            leaders: [],
            workers: [],
            czpVisible: false,
            isCzpLook: false,
            cZPDatas: [],
            czpForm: {
                ticket_code: '', //编号
                addr: '', //配电室名称
                sender_name: '', //发令人
                receiver_name: '', //受令人
                send_time: '', //发令时间
                time_start: '', //操作开始时间
                time_end: '', //操作结束时间
                operationer_name: '', //操作人
                guardian_name: '', //监护人
                checker_name: '', //审核人
                task_list: [],
            },
            addForm3: {
                list: [],
            },
            addForm4: {
                list: [],
                remark: '',
            },
            FileImgs: [],
        };
    },
    computed: {
        uploadDisabled: function () {
            return this.FileImgs.length > 0;
        },
    },
    mounted() {
        this.getCheckResultList();
        this.getCheckRepairState();
        this.getLeader();
    },
    methods: {
        //获取检修状态
        getCheckRepairState() {
            api.getCodelistByKind({
                code_kind: 'check_repair_state',
            }).then((res) => {
                if (res) {
                    this.checkRepairStates = res.bus_json[0].codelists;
                }
            });
        },
        //获取检修结果
        getCheckResultList() {
            api.getCheckResultList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                check_repair_no: this.searchForm.check_repair_no,
                plan_time_start: this.searchForm.plan_time_start,
                check_repair_state: this.searchForm.check_repair_state,
            }).then((res) => {
                if (res) {
                    this.tableData = res.bus_json.items;
                    this.pageNum = res.bus_json.pageNum;
                    this.pageSize = res.bus_json.pageSize;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        //检修记录填写
        inputOverhaulShow(row) {
            this.overExcuteVisible = true;
            this.check_repair_result_id = row.check_repair_result_id;
            this.getCheckResultById(row.check_repair_result_id);
            //查询工作票
            this.getTicketList(this.check_repair_result_id);
            //查询操作票
            this.getTicketOperationList(this.check_repair_result_id);
            //查看备件
            this.getCheckRepairParts(this.check_repair_result_id);
            //查看工作总结
            this.getRepairResultRemark(this.check_repair_result_id);
        },
        //获取检修项目信息
        getCheckResultById(check_repair_result_id) {
            api.getCheckResultById({ check_repair_result_id }).then((res) => {
                if (res) {
                    this.addForm1.repair_tree_list =
                        res.bus_json.repair_tree_list;
                    this.addForm1.check_repair_time_start =
                        res.bus_json.check_repair_time_start;
                    this.addForm1.check_repair_time_end =
                        res.bus_json.check_repair_time_end;
                    this.addForm1.worker_ids = res.bus_json.worker_ids;
                    this.addForm1.out_worker_name =
                        res.bus_json.out_worker_name;
                }
            });
        },
        //保存检修信息
        commitTab1() {
            this.$refs['addForm1'].validate((valid) => {
                let emptyLists = [];
                this.addForm1.repair_tree_list.forEach((item) => {
                    emptyLists.push({
                        check_repair_tree_id: item.check_repair_tree_id,
                        is_complete: item.is_complete == true ? '1' : '0',
                        check_repair_content: item.check_repair_content,
                    });
                });
                if (valid) {
                    api.saveCheckResult({
                        check_repair_result_id: this.check_repair_result_id,
                        check_repair_time_start: this.addForm1
                            .check_repair_time_start,
                        check_repair_time_end: this.addForm1
                            .check_repair_time_end,
                        worker_ids: this.addForm1.worker_ids,
                        out_worker_name: this.addForm1.out_worker_name,
                        repair_tree_list: emptyLists,
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.overExcuteVisible = false;
                            this.getCheckResultList();
                        }
                    });
                }
            });
        },
        //查询工作票
        getTicketList() {
            api.getTicketList({
                check_repair_result_id: this.check_repair_result_id,
            }).then((res) => {
                if (res) {
                    this.gZPDatas = res.bus_json;
                }
            });
        },
        //删除工作票
        deleteGzpItem(row) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                api.deleteTicket({
                    ticket_work_id: row.ticket_work_id,
                    ticket_type: row.ticket_type,
                }).then((res) => {
                    if (res) {
                        this.$message({
                            type: 'success',
                            message: res.error_msg,
                        });
                        this.getTicketList();
                    }
                });
            });
        },
        //修改工作票
        changeGzpShow(row) {
            this.isGzpLook = false;
            this.gzpForm.ticket_type = row.ticket_type;
            if (row.ticket_type == '10') {
                this.firstGzpVisible = true;
            } else {
                this.secondGzpVisible = true;
            }
            this.getTicketById(row.ticket_type, row.ticket_work_id);
        },
        //查看工作票
        arrangeGzpShow(row) {
            this.isGzpLook = true;
            this.gzpForm.ticket_type = row.ticket_type;
            if (row.ticket_type == '10') {
                this.firstGzpVisible = true;
            } else {
                this.secondGzpVisible = true;
            }
            this.getTicketById(row.ticket_type, row.ticket_work_id);
        },
        //工作票内容
        getTicketById(ticket_type, ticket_work_id) {
            api.getTicketById({
                ticket_type,
                ticket_work_id,
            }).then((res) => {
                if (res) {
                    if (ticket_type == '10') {
                        //第一种工作票
                        this.firstGzpForm = { ...res.bus_json };
                        this.leaders.forEach((item) => {
                            if (
                                item.leader_user_id == res.bus_json.leader_name
                            ) {
                                this.workers = item.userList;
                            }
                        });
                        this.firstGzpForm.worker_names = res.bus_json.worker_names.split(
                            ';'
                        );
                    } else {
                        //第二种工作票
                        this.secondGzpForm = { ...res.bus_json };
                        this.leaders.forEach((item) => {
                            if (
                                item.leader_user_id == res.bus_json.leader_name
                            ) {
                                this.workers = item.userList;
                            }
                        });
                        this.secondGzpForm.worker_names = res.bus_json.worker_names.split(
                            ';'
                        );
                    }
                }
            });
        },
        //工作票点击
        gZPClick() {
            this.gzpVisible = true;
        },

        //工作票选择
        commitAddGzp() {
            this.gzpVisible = false;
            this.isGzpLook = false;
            // this.check_repair_result_id = "";
            if (this.gzpForm.ticket_type == '10') {
                this.clearFirstGzpForm();
                this.firstGzpVisible = true;
            } else {
                this.clearSecondGzpForm();
                this.secondGzpVisible = true;
            }
        },
        getLeader() {
            api.getLeader().then((res) => {
                if (res.error_code == 0) {
                    this.leaders = res.bus_json;
                }
            });
        },
        changeLeader(row) {
            this.workers = [];
            this.firstGzpForm.worker_names = '';
            this.leaders.forEach((item) => {
                if (item.leader_user_id == row) {
                    this.workers = item.userList;
                }
            });
        },
        //第一种工作票添加任务
        firstGzpTask() {
            let empty = {
                task_name: '',
                worktask_content_content: '',
            };
            this.firstGzpForm.task_list.push(empty);
        },
        //删除第一种工作票添加任务
        deleteFirstGzpTask(sth) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                console.log('000');
                this.firstGzpForm.task_list.forEach(function (item, index, arr) {
                    console.log(sth, item, index, arr);
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        //第一种工作票安全措施
        firstGzpSafe() {
            let empty = {
                safe_name: '',
                safe_content: '',
            };
            this.firstGzpForm.safe_list.push(empty);
        },
        //删除第一种工作票安全措施
        deleteFirstGzpSafe(sth) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                this.firstGzpForm.safe_list.forEach(function (item, index, arr) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        //第一种工作票时间添加
        firstGzpTime() {
            let empty = {
                start_time: '',
                start_duty_person: '',
                start_agree_person: '',
                end_duty_person: '',
                end_agree_person: '',
            };
            this.firstGzpForm.time_list.push(empty);
        },
        //删除第一种工作票时间
        deleteFirstGzpTime(sth) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                this.firstGzpForm.time_list.forEach(function (item, index, arr) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        //保存第一种工作票
        commitFirstGzp() {
            this.$refs['firstGzpForm'].validate((valid) => {
                if (valid) {
                    api.saveTicket({
                        check_repair_result_id: this.check_repair_result_id,
                        ticket_type: this.gzpForm.ticket_type,
                        ...this.firstGzpForm,
                        worker_names:
                            this.firstGzpForm.worker_names &&
                            this.firstGzpForm.worker_names.join(';'),
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.firstGzpVisible = false;
                            this.getTicketList(this.check_repair_result_id);
                        }
                    });
                }
            });
        },
        changeLeaderSecond(row) {
            this.workers = [];
            this.secondGzpForm.worker_names = '';
            this.leaders.forEach((item) => {
                if (item.leader_user_id == row) {
                    this.workers = item.userList;
                }
            });
        },
        //第二种工作票添加任务
        secondGzpTask() {
            let empty = {
                task_name: '',
                worktask_content_content: '',
            };
            this.secondGzpForm.task_list.push(empty);
        },
        //删除第二种工作票添加任务
        deleteSecondGzpTask(sth) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                this.secondGzpForm.task_list.forEach(function (
                    item,
                    index,
                    arr
                ) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        //保存第二种工作票
        commitSecondGzp() {
            this.$refs['secondGzpForm'].validate((valid) => {
                if (valid) {
                    api.saveTicket({
                        check_repair_result_id: this.check_repair_result_id,
                        ticket_type: this.gzpForm.ticket_type,
                        ...this.secondGzpForm,
                        worker_names:
                            this.secondGzpForm.worker_names &&
                            this.secondGzpForm.worker_names.join(';'),
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.secondGzpVisible = false;
                            this.getTicketList(this.check_repair_result_id);
                        }
                    });
                }
            });
        },
        //操作票添加
        czpClick() {
            this.check_repair_result_id = '';
            this.czpVisible = true;
            this.isCzpLook = false;
        },
        //查询操作票
        getTicketOperationList() {
            api.getTicketOperationList({
                check_repair_result_id: this.check_repair_result_id,
            }).then((res) => {
                if (res) {
                    this.cZPDatas = res.bus_json;
                }
            });
        },
        //修改操作票
        changeCzpShow(row) {
            this.czpVisible = true;
            this.isCzpLook = false;
            this.getTicketOperationById(row.ticket_operation_id);
        },
        //删除操作票
        deleteCzpItem(row) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                api.deleteTicketOperation({
                    ticket_operation_id: row.ticket_operation_id,
                }).then((res) => {
                    if (res) {
                        this.$message({
                            type: 'success',
                            message: res.error_msg,
                        });
                        this.getTicketOperationList();
                    }
                });
            });
        },
        arrangeCzpShow(row) {
            this.czpVisible = true;
            this.isCzpLook = true;
            this.getTicketOperationById(row.ticket_operation_id);
        },
        //查看操作票
        getTicketOperationById(ticket_operation_id) {
            api.getTicketOperationById({
                ticket_operation_id,
            }).then((res) => {
                if (res) {
                    this.czpForm = { ...res.bus_json };
                }
            });
        },
        //操作票添加任务
        czpTask() {
            let empty = {
                task_name: '',
                simulation_content: '',
                real_content: '',
            };
            this.czpForm.task_list.push(empty);
        },
        //删除操作票添加任务
        deleteCzpTask(sth) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                this.czpForm.task_list.forEach(function (item, index, arr) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        //保存操作票
        commitCzp() {
            this.$refs['czpForm'].validate((valid) => {
                if (valid) {
                    api.saveTicketOperation({
                        check_repair_result_id: this.check_repair_result_id,
                        ...this.czpForm,
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.czpVisible = false;
                            //查询操作票
                            this.getTicketOperationList(
                                this.check_repair_result_id
                            );
                        }
                    });
                }
            });
        },
        //查看备件材料
        getCheckRepairParts(check_repair_result_id) {
            api.getCheckRepairParts({
                check_repair_result_id,
            }).then((res) => {
                if (res) {
                    this.addForm3.list = res.bus_json;
                }
            });
        },
        //添加备件/材料
        addBeiJian() {
            let emptyItem = {
                parts_name: '',
                parts_model: '',
                parts_num: '',
                parts_unit: '',
            };
            this.addForm3.list.push(emptyItem);
        },
        //删除备件/材料
        deleteItem(sth) {
            this.$confirm('确认删除这条数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then((_) => {
                this.addForm3.list.forEach(function (item, index, arr) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
                console.log('ddd:', this.addForm3);
                this.commitTab3();
            });
        },
        //备件/材料消耗提交
        commitTab3() {
            this.$refs['addForm3'].validate((valid) => {
                if (valid) {
                    api.saveCheckRepairParts({
                        check_repair_result_id: this.check_repair_result_id,
                        list: this.addForm3.list,
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.getCheckRepairParts(
                                this.check_repair_result_id
                            );
                            this.getCheckResultList();
                            this.overExcuteVisible = false;
                        }
                    });
                }
            });
        },
        //查看工作总结
        getRepairResultRemark(check_repair_result_id) {
            api.getRepairResultRemark({
                check_repair_result_id,
            }).then((res) => {
                if (res) {
                    this.addForm4.remark = res.bus_json.remark;
                    this.addForm4.list = res.bus_json.list;
                    this.FileImgs = [];
                    this.addForm4.list.forEach((item) => {
                        this.FileImgs.push({
                            file_id: item.file_id,
                            url:
                                process.env.VUE_APP_3D_URL +
                                '/' +
                                item.file_path,
                        });
                    });
                }
            });
        },
        // 图片上传
        uploadFile(file) {
            const isLt2M = file.file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!,请重新上传！');
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('file_type', '60');
            api.uploadAvatar(formData).then((res) => {
                if (res) {
                    this.FileImgs.push({
                        file_id: res.bus_json.file_id,
                        url:
                            process.env.VUE_APP_3D_URL +
                            '/' +
                            res.bus_json.file_path,
                    });
                    this.addForm4.list = this.FileImgs;
                    this.$message({
                        type: 'success',
                        message: res.error_msg,
                    });
                }
            });
        },
        handleRemove(file) {
            this.addForm4.list.forEach((item) => {
                if (file.file_id == item.file_id) {
                    this.addForm4.list.splice(item, 1);
                }
            });
            this.FileImgs = this.FileImgs.filter(
                (item) => item.file_id !== file.file_id
            );
        },
        //工作总结提交
        commitTab4() {
            this.$refs['addForm4'].validate((valid) => {
                if (valid) {
                    api.saveRepairResultRemark({
                        remark: this.addForm4.remark,
                        list: this.addForm4.list,
                        check_repair_result_id: this.check_repair_result_id,
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.getRepairResultRemark(
                                this.check_repair_result_id
                            );
                            this.getCheckResultList();
                            this.overExcuteVisible = false;
                        }
                    });
                }
            });
        },
        //登记缺陷
        checkInDefect() {
            this.defentDialogVisible = true;
        },
        closeDialog() {
            // this.$refs["addForm"].resetFields();
            // this.$refs["addForm"].clearValidate();
            this.overExcuteVisible = false;
            // this.addForm.deviceTags = [];
            // this.addForm.deviceIds = [];
        },
        //关闭工作票选择
        closeDialogGzp() {
            this.gzpVisible = false;
            this.$refs['gzpForm'].resetFields();
            this.$refs['gzpForm'].clearValidate();
        },
        //关闭第一种工作票
        closeDialogFirstGzp() {
            this.firstGzpVisible = false;
            this.$refs['firstGzpForm'].resetFields();
            this.$refs['firstGzpForm'].clearValidate();
        },
        //关闭第二种工作票
        closeDialogSecondGzp() {
            this.secondGzpVisible = false;
            this.$refs['secondGzpForm'].resetFields();
            this.$refs['secondGzpForm'].clearValidate();
        },
        //关闭操作票
        closeDialogCzp() {
            this.czpVisible = false;
            this.$refs['czpForm'].resetFields();
            this.$refs['czpForm'].clearValidate();
        },
        //清空第一种工作票表单
        clearFirstGzpForm() {
            this.firstGzpForm.ticket_code = ''; //编号
            this.firstGzpForm.addr = ''; //工作变配电室名称
            this.firstGzpForm.leader_name = ''; //工作负责人
            this.firstGzpForm.worker_names = '';
            this.firstGzpForm.task_list = []; //工作任务
            this.firstGzpForm.plan_time_start = '';
            this.firstGzpForm.plan_time_end = '';
            this.firstGzpForm.safe_list = []; //安全措施
            this.firstGzpForm.work_send_person = ''; //工作票签发人签名
            this.firstGzpForm.work_send_time = ''; //签发时间
            this.firstGzpForm.work_agree_time_start = ''; //许可开始时间
            this.firstGzpForm.work_agree_person = ''; //工作许可人签名
            this.firstGzpForm.work_leader_name = ''; //工作负责人签名
            this.firstGzpForm.require_works_name = ''; //工作班组人员签名
            this.firstGzpForm.change_content_from = ''; //原工作负责人
            this.firstGzpForm.change_content_to = ''; //变更后负责人
            this.firstGzpForm.change_send_person = ''; //工作票签发人签名
            this.firstGzpForm.change_send_time = ''; //变动负责人工作票签发时间
            this.firstGzpForm.change_agree_person = ''; //变动工作许可人签名
            this.firstGzpForm.change_agree_time = ''; //变动负责人工作许可人签名日期
            this.firstGzpForm.change_content = ''; //变动情况说明
            this.firstGzpForm.change_worker_leader_name = ''; //变动工人负责人签名
            this.firstGzpForm.delay_to_time = ''; //有效期延长到
            this.firstGzpForm.delay_duty_person = ''; //工作负责人签名
            this.firstGzpForm.delay_duty_time = ''; //工作负责人签名日期
            this.firstGzpForm.delay_agree_person = ''; //工作许可人签名
            this.firstGzpForm.delay_agree_time = ''; //工作许可人签名日期
            this.firstGzpForm.time_list = []; //每日开工和收工时间
            this.firstGzpForm.finish_content_time = ''; //总结结束时间
            this.firstGzpForm.finish_content_no = ''; //总结接地线编号
            this.firstGzpForm.finish_content_groups = ''; //总结接地线组数
            this.firstGzpForm.finish_content_count = ''; //接地刀闸台数
            this.firstGzpForm.un_finish_content = ''; //总结未结束
            this.firstGzpForm.un_finish_content_no = ''; //总结未结束接地线编号
            this.firstGzpForm.un_finish_content_groups = ''; //总结未结束接地线组数
            this.firstGzpForm.un_finish_content_count = ''; //未结束接地刀闸台数
            this.firstGzpForm.finish_duty_person = ''; //总结工作负责人签名
            this.firstGzpForm.finish_duty_time = ''; //总结工作负责人签名日期
            this.firstGzpForm.finish_agree_person = ''; //总结工作许可人签名
            this.firstGzpForm.finish_agree_time = ''; //
        },
        //清空第二种工作票表单
        clearSecondGzpForm() {
            this.secondGzpForm = {
                ticket_code: '', //编号
                addr: '', //变配电室名称
                leader_name: '', //工作负责人
                worker_names: '', //工作班成员
                task_list: [], //工作任务
                plan_time_start: '', //计划开始时间
                plan_time_end: '', //计划结束时间
                condition: '', //工作条件
                duty_person: '', //工作票负责人
                agree_person: '', //工作票许可人
                work_send_person: '', //工作票签发人
                work_leader_name: '', //工作负责人
                work_agree_person: '', //工作许可人
                work_agree_time: '', //工作许可时间
                require_works_name: '', //确认工作负责人-工作人员
                delay_to_time: '', //有效期延长到
                delay_duty_person: '', //工作负责人签名
                delay_duty_time: '', //工作负责人签名日期
                delay_agree_person: '', //工作许可人签名
                delay_agree_time: '', //工作许可人签名日期
                finish_content_time: '', //
                finish_duty_person: '', //总结工作负责人签名
                finish_duty_time: '', //总结工作负责人签名日期
                finish_agree_person: '', //总结工作许可人签名
                finish_agree_time: '', //总结工作许可人签名日期
                remark: '',
            };
        },
    },
};
</script>
<style lang="scss">
.overhaul-excute-con {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .them_font_color {
        // @include font_color;
    }

    .el-card__header {
        /*border-bottom: 1px solid #56fbff;*/
    }
    .avatar-uploader {
        .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
            width: 100px;
            height: 100px;
        }
    }
    .disabled .el-upload--picture-card {
        display: none;
    }
}
</style>
